import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';
import styled from '@emotion/styled';
import { fontStack } from '../utils/fontStack';
import { Heading } from '../Typography';
import { Link } from '../Link';
import { Code } from './components/Code';
import { MarkdownTable } from './components/MarkdownTable';
export var libraryOverrides = {
    intro: {
        component: Heading,
        props: {
            element: 'h1',
            variant: 'intro',
        },
    },
    h1: {
        component: Heading,
        props: {
            element: 'h1',
            variant: 'h1',
        },
    },
    h2: {
        component: Heading,
        props: {
            element: 'h2',
            variant: 'h2',
        },
    },
    h3: {
        component: Heading,
        props: {
            element: 'h3',
            variant: 'h3',
        },
    },
    h4: {
        component: Heading,
        props: {
            element: 'h4',
            variant: 'h4',
        },
    },
    h5: {
        component: Heading,
        props: {
            element: 'h5',
            variant: 'h5',
        },
    },
    h6: {
        component: Heading,
        props: {
            element: 'h6',
            variant: 'h6',
        },
    },
    a: {
        component: Link,
        props: {
            target: '_blank',
        },
    },
    code: Code,
    table: MarkdownTable,
};
export var CustomMarkdown = styled(function (_a) {
    var children = _a.children, options = _a.options, overrides = _a.overrides, props = __rest(_a, ["children", "options", "overrides"]);
    return (React.createElement(Markdown, __assign({ options: __assign(__assign({}, options), { overrides: __assign(__assign({}, libraryOverrides), (overrides || {})) }) }, props), children));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  line-height: 20px;\n"], ["\n  ", "\n  line-height: 20px;\n"])), fontStack);
CustomMarkdown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    options: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    overrides: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.string.isRequired,
};
var templateObject_1;
//# sourceMappingURL=CustomMarkdown.js.map